<template>
  <div class="sjbz">
    <div class="card1">
      <div class="w1280">
        <div style="padding: 112px 0;">
          <div class="t11">数据标注</div>
          <div class="t22">
            为您提供多应用场景和行业的定制数据标注服务，为您的AI应用提供全面数据。
          </div>
        </div>
      </div>
    </div>
    <div class="card2"> 
      <div class="title">数据标注能力</div>
      <div class="slogan">
        支持全数据类型的标注，包括大模型类、图像视频、3D类、语音、文本、以及内容相关性的标注，并有全面的智能标注工具支持，为您创建定制数据。
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/p1.png"
              alt=""
            />
          </div>
          <div style="width: 45%;">
            <div class="t1">大模型标注</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>指令标注</li>
                  <li>指令泛化</li>
                  <li>指令CoT描述</li>
                  <li>答案修正</li>
                  <li>答案意图槽位标注</li>
                  <li>答案打分排序</li>
                  <li>答案内容标注</li>
                  <li>人机对话</li>
                  <li>多模态标注</li>
                </ul>
              </div>
              <div style="width: 50%;">
                <ul>
                  <li>代码类标注</li>
                  <li>数学问题标注</li>
                  <li>公式标注</li>
                  <li>毒性任务标注</li>
                  <li>特定领域知识标注</li>
                  <li>百科知识真实性评测</li>
                  <li>摘要抽取</li>
                  <li>物品/人像描述标注</li>
                  <li>文档结构逻辑标注</li>
                </ul>
              </div>
            </div>
            <div class="btn1" @click="go('/callMe')">
              项目咨询
              <i class="el-icon-right"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 45%;">
            <div class="t1">图像视频标注</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>矩形框标注</li>
                  <li>多边形标注</li>
                  <li>关键点标注</li>
                  <li>骨骼关键点组标注</li>
                  <li>立体框标注</li>
                  <li>折线标注</li>
                  <li>栅格标注</li>
                  <li>圆/椭圆标注</li>
                  <li>平滑曲线标注</li>
                  <li>色块标注</li>
                </ul>
              </div>
              <div style="width: 50%;">
                <ul>
                  <li>图像分类</li>
                  <li>街景语义分割</li>
                  <li>车道线标注</li>
                  <li>人脸关键点</li>
                  <li>人像语义分割（发丝抠图）</li>
                  <li>手部标注</li>
                  <li>手势/动作标注</li>
                  <li>鱼眼标注</li>
                  <li>居家环境标注</li>
                  <li>宠物识别/关键点标注</li>
                </ul>
              </div>
            </div>
            <div class="btn1"  @click="go('/callMe')">
              项目咨询
              <i class="el-icon-right"></i>
            </div>
          </div>
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/p2.gif"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/p3.gif"
              alt=""
            />
          </div>
          <div style="width: 45%;">
            <div class="t1">3D标注</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>2/3D融合标注</li>
                  <li>3D点云语义分割</li>
                  <li>3D点云立体框标注</li>
                  <li>3D点云连续帧标注</li>
                  <li>3D全景/多视角标注</li>
                  <li>多维度点云颜色渲染工具</li>
                  <li>单点、笔刷、多边形等标注工具</li>
                </ul>
              </div>
              <div style="width: 50%;">
                <ul>
                  <li>3D障碍物标注</li>
                  <li>3D行人车辆标注</li>
                  <li>3D可停车区域标注</li>
                  <li>3D车道线标注</li>
                  <li>3D手部/人体标注</li>
                  <li>3D农田标注</li>
                </ul>
              </div>
            </div>
            <div class="btn1"  @click="go('/callMe')">
              项目咨询
              <i class="el-icon-right"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 45%;">
            <div class="t1">多语言文本标注</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>文本清洗</li>
                  <li>文本分类</li>
                  <li>情绪标注</li>
                  <li>意图识别标注</li>
                  <li>词性标注</li>
                  <li>平行语料对</li>
                  <li>词槽标注</li>
                  <li>模拟对话标注</li>
                  <li>实体词识别标注</li>
                  <li>知识图谱</li>
                </ul>
              </div>
              <div style="width: 50%;">
                <ul>
                  <li>OCR标注</li>
                  <li>票据标注</li>
                  <li>公式标注</li>
                  <li>教育教辅标注</li>
                  <li>多语言标注</li>
                  <li>阿拉伯语标注</li>
                  <li>日语韩语标注</li>
                  <li>西班牙语/葡萄牙语/法语/德语标注</li>
                  <li>泰语/马来语/越南语标注</li>
                  <li>小语种标注</li>
                </ul>
              </div>
            </div>
            <div class="btn1"  @click="go('/callMe')">
              项目咨询
              <i class="el-icon-right"></i>
            </div>
          </div>
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/p4.gif"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/p5.png"
              alt=""
            />
          </div>
          <div style="width: 45%;">
            <div class="t1">多语言语音标注</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>语音清洗</li>
                  <li>语音切分</li>
                  <li>语音转写</li>
                  <li>音素标注</li>
                  <li>情绪标注</li>
                  <li>韵律标注</li>
                  <li>小语种发音词典</li>
                  <li>方言发音词典</li>
                </ul>
              </div>
              <div style="width: 50%;">
                <ul>
                  <li>多语言方言转写标注</li>
                  <li>小语种转写标注</li>
                  <li>多人对话标注</li>
                  <li>音乐标注</li>
                  <li>声纹识别标注</li>
                  <li>噪音标注</li>
                  <li>宠物叫声标注</li>
                  <li>婴儿啼哭标注</li>
                </ul>
              </div>
            </div>
            <div class="btn1"  @click="go('/callMe')">
              项目咨询
              <i class="el-icon-right"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 45%;">
            <div class="t1">内容相关性标注</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>搜索引擎结果评估</li>
                  <li>广告相关性与质量评估</li>
                  <li>商品搜索结果评估</li>
                  <li>地图搜索结果精度评估</li>
                  <div style="height: 20px;"></div>
                  <li>医疗相关性标注</li>
                  <li>教育相关性标注</li>
                  <li>游戏相关性标注</li>
                  <li>音乐相关性标注</li>
                </ul>
              </div>
              <div style="width: 50%;">
                <ul>
                  <li>内容质量审核</li>
                  <li>视频合规性审核</li>
                  <li>多品类内容时效性评估</li>
                  <li>商品描述与评论审核</li>
                  <div style="height: 20px;"></div>
                  <li>广告分类</li>
                  <li>视频标签分类</li>
                  <li>英语内容分类&评估</li>
                </ul>
              </div>
            </div>
            <div class="btn1"  @click="go('/callMe')">
              项目咨询
              <i class="el-icon-right"></i>
            </div>
          </div>
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/p6.webp"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card2"> 
      <div class="title">行业标注能力</div>
      <div class="slogan">
        数据标注团队支持多模态全行业的数据标注服务，支持您进行定制化模型训练。
      </div>
      <div class="w1280">
        <div class="flexs">
          <div class="card-sx" v-for="(item, index) in cardList" :key="index">
            <img
              style="width: 405px;height: 192px;border-radius:8px 8px 0 0;"
              :src="item.img"
              alt=""
            />
            <div class="contents">
              <div class="t1">{{ item.title }}</div>
              <div
                v-for="(item1, index1) in item.textList"
                :key="index1"
                class="t2"
              >
                {{ item1.title }}<span class="t3">{{ item1.content }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">资源与工具</div>
      <div class="slogan">
        资源优势体现在人员资源，软件支持，以及工具支持等方面，为大规模高效AI部署奠定基础。
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 45%;">
            <div class="t1">数据标注平台</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 48%;margin-right: 4%;">
                <div style="color: #333;font-weight: bold;margin-bottom: 24px;">
                  全面的标注工具
                </div>
                <ul style="margin-left: 32px;">
                  <li>
                    包括图像、视频、点云、文本、语音、大模型、相关性等标注工具
                  </li>
                  <li>
                    智能标注：AI辅助的智能预标注与智能质检，采用人机协同方式，支持高效高质量的标注
                  </li>
                  <li>工具定制：根据用户标注需求进行工具开发和定制功能设定</li>
                </ul>
              </div>
              <div style="width: 48%;">
                <div style="color: #333;font-weight: bold;margin-bottom: 24px;">
                  工作流支持
                </div>
                <div>
                  标注平台的工作流高度适配复杂的标注需求，支持高效的项目管理和数据管理。
                </div>
                <ul style="margin-left: 32px;">
                  <li>集中式数据中心</li>
                  <li>任务可视化</li>
                  <li>并行工作流</li>
                  <li>定向质检</li>
                  <li>工作流自定义</li>
                </ul>
              </div>
            </div>
          </div>
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/q1.webp"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/q2.webp"
              alt=""
            />
          </div>
          <div style="width: 45%;">
            <div class="t1">标注资源&管理</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 48%;margin-right: 4%;">
                <div style="color: #333;font-weight: bold;margin-bottom: 24px;">
                  全球众包
                </div>
                <div>
                  在全球有众多的众包资源，覆盖超过290+种语言和方言，可以快速响应客户需求。
                </div>
              </div>
              <div style="width: 48%;">
                <div style="color: #333;font-weight: bold;margin-bottom: 24px;">
                  基地资源
                </div>
                <div>
                  在国内拥有多家自有基地及合作基地，包含内部标注员1000+，为您的高数据安全要求提供高效支持。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card4">
      <div class="card4-t1">数据的隐私安全</div>
      <div class="flexs" style="flex-wrap: wrap;">
        <div class="item-card" v-for="(item, index) in cardList1" :key="index">
          <img style="width: 48px;" :src="item.img" alt="" />
          <div style="font-size: 20px;margin:20px 0;color: #000;">{{ item.name }}</div>
          <ul>
            <li style="font-size: 16px;line-height: 1.5;color: #4b4f54;" v-for="(item1, index1) in item.list" :key="index1">{{ item1.t }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="w1280">
      <div class="flexs">
        <div style="width:48%">
          <img style='width:48%;margin-right: 4%;' src="../assets/img/1.png" alt="" />
          <img style='width:48%' src="../assets/img/5.png" alt="" />
        </div>
        <div style="width:48%">
          <div style="color:#045588;font-size:32px;font-weight:600;margin-bottom:24px">数据安全与质量证书</div>
          <div style="line-height:1.5">安全解决方案产品组合包括经 ISO 27001，ISO 27701，ISO9001，GDPR，SOC 2 类型 II 认证，及 HIPPA 认证的安全设备、现场服务、安全众包模型和技术解决方案。</div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">我们的优势</div>
      <div class="w1280" style="">
        <div class="flexs" style="flex-wrap: wrap;margin:32px 128px">
          <div class="card-ys" v-for="(item, index) in ysList" :key="index">
            <img style="width:48px;height:48px;margin-bottom:8px" :src="item.img" alt="" />
            <div class="t1">{{item.name}}</div>
            <div class="t2">{{item.content}}</div>
          </div>
        </div>
      </div>
      </div>
    <div class="card-footer">
      <div class="t1">全AI流程数据标注服务</div>
      <div class="t2">全类型、多模态、高效率的数据标注服务</div>
      <div class="btns" @click="go('/callMe')">预约试标</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ysList:[
        {
          name: "资源丰富",
          content:
            "国内基地拥有众多标注员，合作基地1000+标注员，以及众多国内众包。",
          img: require("../assets/img/sjfw/e1.svg"),
        },
        {
          name: "平台技术",
          content:
            "平台集成丰富高效的标注工具，将AI和模型能力有效整合，具备强大的工作流调度能力。以大规模人机协同的方式 ，支持丰富场景海量数据的各种类型标注项目。",
          img: require("../assets/img/sjfw/e2.svg"),
        },
        {
          name: "安全可靠",
          content:
            "通过了ISO27001,ISO9001与ISO27701，以及EHS证书，同时搭建了多个合规室/安全屋，同时有1000+内部标注员为您的高安全要求提供支持。",
          img: require("../assets/img/sjfw/e3.svg"),
        },
        {
          name: "业务专家",
          content:
            "拥有众多项目交付的业务经验，涵盖多垂直领域，与客户迅速对齐规则，并给客户提供建设性建议。",
          img: require("../assets/img/sjfw/e4.svg"),
        },],
      cardList1: [
        {
          name: "数据存储与传输",
          list:[{t:'国安级加密云技术保证数据传输和存储安全'},{t:'业界领先的Appen Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别'}],
          img: require("../assets/img/sjfw/x1.svg"),
        },
        {
          name: "项目现场与监管",
         list:[{t:'项目现场配置人脸识别和指纹门禁'},{t:'设有加密项目房间，仅授权人员准许进入 Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别'},{t:'配有24*7值班人员以及无死角摄像头监控现场'}],
          img: require("../assets/img/sjfw/x2.svg"),
        },
        {
          name: "雇员与被采人管控",
          list:[{t:'标注人员及供应商签署保密协议'},{t:'全体员工办公设备均统一管理'}],
          img: require("../assets/img/sjfw/x3.svg"),
        }
      ],
      cardList: [
        {
          title: "智能驾驶",
          img: require("../assets/img/sjfw/s1.webp"),
          textList: [
            {
              title: "自动驾驶3D点云标注：",
              content: "车辆标注，车道线标注，障碍物标注，泊车标注",
            },
            {
              title: "自动驾驶2D标注：",
              content: "车牌标注，信号灯标注，可行驶区域标注，鱼眼标注",
            },
            {
              title: "DMS驾驶员行为标注：",
              content: "人脸标注，疲劳标注，危险动作标注，视线定位标注",
            },
            {
              title: "舱内语音交互数据标注：",
              content: "唤醒词，指令词，ASR标注，涵盖多语言多方言多地区",
            },
          ],
        },
        {
          title: "医疗健康",
          img: require("../assets/img/sjfw/s2.webp"),
          textList: [
            {
              title: "医学图像标注：",
              content: "对放射、超声、病理、内镜、心脑电图等进行辅助诊断标注",
            },
            {
              title: "医学文本标注：",
              content:
                "对医学内容进行分析、处理、OCR转化以及NER实体标注，深入理解专业领域内容，使自然语言理解更加专业深入",
            },
            {
              title: "医学内容审核：",
              content:
                "对医学科普、医学问答、医院病史等原始数据进行筛选、检索、分类、审核修改等处理，实现医疗产品所需的功能",
            },
          ],
        },
        {
          title: "产品应用出海",
          img: require("../assets/img/sjfw/s3.webp"),
          textList: [
            {
              title: "应用本地化：",
              content:
                "词槽标注​，平行语料对，意图识别，情绪标注，语音转写，TTS，字幕机翻校译等",
            },
            {
              title: "多语言审核：",
              content:
                "多语言视频审核，应用搜索结果评估，包括英语、欧洲、中东、亚洲、非洲等100多种语言方言",
            },
            {
              title: "海外众测：",
              content:
                "多国家地区的人员测试团队，针对应用的使用效果、本地化效果、翻译等进行全面测试评估",
            },
          ],
        },
      ],
    };
  },
  methods: {
    go(path) {
      this.$router.push(path);
    }
  },
};
</script>
<style lang="scss" scoped>
.sjbz {
  .card1 {
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    width: 100%;
    height: 370px;
  }
  .card4 {
    width: 1280px;
    margin: 48px auto;
    text-align: center;
    .item-card2{
      flex-shrink: 0;
      text-align: center;
      width: 340px;
      margin: 40px 30px ;
    }
    .item-card {
      height: 240px;
      flex-shrink: 0;
      padding: 40px 24px;
      background-color: #eceff0;
      border-radius: 8px;
      width: 360px;
      margin-top: 20px;
      text-align: left;
      font-size: 16px;
    }
    .select-tab {
      margin: 30px 0 20px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 38px;
      line-height: 38px;
      align-content: center;
      padding: 2px;
      border-radius: 25px;
      border-width: 1px;
      border-style: solid;
      border-color: #000;
      border-image: initial;
      .s-tabs {
        width: 20%;
        height: 38px;
        text-align: center;
        cursor: pointer;
        border-radius: 25px;
      }
      .is-active {
        color: rgb(255, 255, 255);
        background: #045588;
      }
    }
    .card4-t1 {
      color: #045588;
      font-size: 48px;
      font-weight: bold;
    }
    .card4-t2 {
      font-size: 16px;
      width: 680px;
      margin: 24px auto 0;
      line-height: 1.5;
    }
    .card4-t3 {
      font-size: 32px;
      text-align: left;
      margin-bottom: 56px;
      color: #045588;
      font-weight: bold;
    }
    .btns {
      cursor: pointer;
      margin-top: 32px;
      width: 150px;
      background-color: #099fee;
      color: #fff;
      height: 48px;
      line-height: 48px;
      padding: 0 20px;
      border-radius: 8px;
    }
  }
  .card2 {
    width: 1280px;
    margin: 0 auto;
    .card-ys{
      width:448px;
      height:178px;
      padding: 24px;
      background-color: #eceff0;
      border-radius: 8px;
      margin-top:24px;
      .t1{
        font-size:20px;
        color: #25282a;
        margin-bottom: 16px;
      }.t2{
        font-size:16px;
        color: #25282a;
      }
    }
    .card-sx {
      width: 405px;

      margin: 0 0 48px;
      .contents {
        padding: 24px;
        height: 328px;
        background-color: #eceff0;
        border-radius: 0 0 8px 8px;
        .t1 {
          color: #045588;
          font-size: 24px;
          font-weight: 500;
          margin-bottom: 32px;
        }
        .t2 {
          color: #4b4f54;
          font-weight: bold;
          font-size: 16px;
          margin-bottom: 24px;
        }
        .t3 {
          font-weight: normal;
        }
      }
    }
    li {
      line-height: 1.5;
    }
    .t1 {
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
      font-weight: 500;
    }
    .title {
      color: #045588;
      text-align: center;
      margin-top: 64px;
      font-weight: 500;
      font-size: 48px;
      margin-bottom: 8px;
    }
    .slogan {
      color: rgb(75, 79, 84);
      font-size: 16px;
      text-align: center;
      line-height: 1.2;
      width: 768px;
      margin: 0 auto 64px;
    }
  }
  .card-footer {
    width: 100%;
    height: 328px;
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    .t1 {
      color: rgb(0, 126, 204);
      font-weight: 500;
      font-size: 50px;
      text-align: center;
      padding-top: 60px;
    }
    .t2 {
      text-align: center;
      margin-top: 24px;
    }
    .btns {
      cursor: pointer;
      text-align: center;
      background-image: linear-gradient(
        260.38deg,
        #099fee 3.89%,
        #2247da 143.13%
      );
      width: 96px;
      height: 48px;
      padding: 0 16px;
      line-height: 48px;
      color: #fff;
      margin: 24px auto 0;
      border-radius: 8px;
    }
  }
  .btn1 {
    cursor: pointer;
    width: 120px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    background-color: #099fee;
    border-radius: 8px;
  }
  .w1280 {
    width: 1280px;
    margin: 0 auto;
    .t11 {
      color: #045588;
      font-size: 56px;
      font-weight: bold;
      line-height: 84px;
      text-align: center;
    }
    .t22 {
      margin: 32px 256px;
      text-align: center;
      font-size: 20px;
      color: #4b4f54bf;
    }
  }
  .flexs {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
<style></style>
